import React, { Component } from "react";
import { FaPaperPlane, FaPlus, FaSave, FaTimes, FaTrash } from "react-icons/fa";
import { Timeline, Button, Comment, Input, List, Form, Select, message } from "antd";
import moment from "moment";
import "./ClientNotes.scss";
import { connect } from "react-redux";
import {
  AddOrUpdateComment,
  AddOrUpdateReply,
  DeleteComment,
  DeleteReply,
  GetAllComments,
} from "../../network/request.network";

const { TextArea } = Input;

class ClientNotes extends Component {
  state = {
    showAddNote: false,
    btnLoading: false,
    allComments: [],
    showReplayForm: false,
    replayVal: "",
  };

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    let { orderId } = this.props;
    let body = {
      Id: orderId,
      Page: 0,
    };
    GetAllComments(
      body,
      (res) => {
        this.setState({ allComments: res.data.model.filter(comm => comm.AspNetUsers?.UserTypeId === 1) });
      },
      (error) => {}
    );
  };

  onFinish = (values) => {
    this.setState({ btnLoading: true });
    let body = {
      Id: 0,
      FinancingRequestId: this.props.orderId,
      FinancingRequestCommentTypeId: values.orderFound,
      Comment: values.orderType,
    };
    AddOrUpdateComment(
      body,
      (res) => {
        this.setState({ showAddNote: false, btnLoading: false });
        this.getData();
        message.success("تم إضافة الملاحظة بنجاح");
        this.props.updateNotesBadge(this.props.orderId);
      },
      (error) => {
        message.error("حدث خطأ ما من فضلك أعد المحاولة");
        this.setState({ btnLoading: false });
      }
    );
  };

  deleteComment = (id) => {
    DeleteComment(
      id,
      () => {
        message.success("تم حذف الملاحظة بنجاح");
        this.getData();
        this.props.updateNotesBadge(this.props.orderId);
      },
      (error) => {}
    );
  };

  deleteReplay = (id) => {
    DeleteReply(
      id,
      () => {
        message.success("تم حذف الرد بنجاح");
        this.getData();
      },
      (error) => {}
    );
  };

  showInputReplay = (id) => {
    let eleClass = "cint" + id;
    document.getElementsByClassName(eleClass)[0].style.visibility = "visible";
  };

  sendReplay = (values, commentId) => {
    let body = {
      Id: 0,
      FinancingRequestCommentId: commentId,
      Reply: values.replay,
    };

    AddOrUpdateReply(
      body,
      () => {
        message.success("تم إضافة الرد بنجاح");
        this.getData();
        this.setState({ replayVal: "" });
      },
      () => {}
    );
    let eleClass = "cint" + commentId;
    document.getElementsByClassName(eleClass)[0].style.visibility = "hidden";
  };

  render() {
    const { showAddNote } = this.state;
    return (
      <div className="client-info-wrapper client-nots-wrapper">
        {showAddNote ? (
          <header className="client-header">
            <h2 className="header-title" style={{ color: "#06ACCC" }}>
              اضافه ملاحظه جديده
            </h2>
          </header>
        ) : (
          <header className="client-header">
            <h2 className="header-title">الملاحظات</h2>
            <div className="header-btn-holder">
              <Button
                type="primary"
                size="large"
                ghost
                className="blue-btn"
                onClick={() => this.setState({ showAddNote: true })}
                icon={<FaPlus />}
              >
                اضافه ملاحظه
              </Button>
            </div>
          </header>
        )}
        <div className="nots-content-wrapper">
          {showAddNote ? (
            <Form
              className="form-add-content"
              layout="vertical"
              name="nest-messages"
              onFinish={this.onFinish}
            >
              <div className="form-content form-content-one-col">
                <Form.Item
                  label="نوع الملاحظه"
                  name="orderFound"
                  className="input-holder"
                >
                  <Select>
                    {this.props?.FinancingRequestCommentTypes?.map(
                      (sources) => {
                        return (
                          <Select.Option key={sources.Id} value={sources.Id}>
                            {sources.NameLT}
                          </Select.Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="نوع الخدمة المقدمة"
                  name="orderType"
                  className="input-holder"
                >
                  <TextArea autoSize={{ minRows: 6, maxRows: 9 }} />
                </Form.Item>
              </div>
              <div className="form-add-btns">
                <Button
                  type="primary"
                  size="large"
                  className="blue-btn xlg"
                  icon={<FaSave />}
                  htmlType="submit"
                  loading={this.state.btnLoading}
                >
                  حفظ
                </Button>
                <Button
                  type="primary"
                  size="large"
                  className="red-btn xlg"
                  onClick={() => this.setState({ showAddNote: false })}
                  icon={<FaTimes />}
                >
                  الغاء
                </Button>
              </div>
            </Form>
          ) : (
            <Timeline>
              <List
                className="comment-list"
                itemLayout="horizontal"
                dataSource={this.state.allComments}
                renderItem={(item) => (
                  <Timeline.Item>
                    <li
                      className="comment-list-nest-wrapper"
                      keys={item.Comment + item.Id}
                    >
                      <Comment
                        content={
                          <div className="comment-content">
                            <div className="comment-top">
                              <div className="comment-top-info">
                                <h3 className="comment-title-type">{item?.FinancingRequestCommentType?.NameLT}</h3>
                                <h4 className="comment-title">{item?.Comment}</h4>
                                <div className="comment-meta">
                                  <span className="meta-name">
                                    {item.AspNetUsers.FullName}
                                  </span>
                                  <span className="meta-date">
                                    {moment
                                      .utc(item.CreationDate)
                                      .format("DD/MM/YYYY - HH:MM")}
                                  </span>
                                </div>
                              </div>
                              <div className="comment-top-action">
                                <span
                                  className="comment-list-reply"
                                  onClick={() => this.showInputReplay(item.Id)}
                                >
                                  {" "}
                                  <FaPaperPlane /> اضافه رد{" "}
                                </span>
                                {this.props.userId === item.AspNetUsers.Id && (
                                  <i
                                    className="delete-reply"
                                    onClick={() => this.deleteComment(item.Id)}
                                  >
                                    <FaTrash />
                                  </i>
                                )}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        {item.FinancingRequestReplies.map((replay) => (
                          <Comment
                            keys={replay.Id}
                            content={
                              <div className="comment-content">
                                <div className="comment-top">
                                  <div className="comment-top-info">
                                    <h4 className="comment-title">
                                      {replay.Reply}
                                    </h4>
                                    <div className="comment-meta">
                                      <span className="meta-name">
                                        {replay?.AspNetUsers?.FullName}
                                      </span>
                                      <span className="meta-date">
                                        {moment
                                          .utc(replay?.CreationDate)
                                          .format("DD/MM/YYYY - HH:MM")}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="comment-top-action">
                                    {this.props.userId ===
                                      replay.AspNetUsers.Id && (
                                      <i
                                        className="delete-reply"
                                        onClick={() =>
                                          this.deleteReplay(replay.Id)
                                        }
                                      >
                                        <FaTrash />
                                      </i>
                                    )}
                                  </div>
                                </div>
                              </div>
                            }
                          />
                        ))}
                        {
                          <div className={`comment-input cint${item.Id}`}>
                            <Form onFinish={(v) => this.sendReplay(v, item.Id)}>
                              <Form.Item
                                name="replay"
                                rules={[
                                  {
                                    required: true,
                                    message: "من فضلك قم بكتابة الرد",
                                  },
                                ]}
                              >
                                <Input
                                  value={this.state.replayVal}
                                  suffix={
                                    <button htmlType="submit">
                                      <FaPaperPlane className="send-icon" />
                                    </button>
                                  }
                                />
                              </Form.Item>
                            </Form>
                          </div>
                        }
                      </Comment>
                    </li>
                  </Timeline.Item>
                )}
              />
            </Timeline>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  FinancingRequestCommentTypes: state.user.metaData.FinancingRequestCommentTypes,
  RequestDetails: state.order.RequestDetails,
  userId: state.user.currentUser.Id,
});
export default connect(mapStateToProps)(ClientNotes);